/**
 * Learn page — scroll-spy for sidebar navigation.
 *
 * Uses IntersectionObserver to highlight the current section
 * in the sidebar as the user scrolls.
 */

function init(): void {
  const sections = document.querySelectorAll('.learn-section');
  const links = document.querySelectorAll('.learn-nav-link');

  if (!sections.length || !links.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          links.forEach((l) => l.classList.remove('active'));
          const active = document.querySelector(
            `.learn-nav-link[data-section="${entry.target.id}"]`,
          );
          if (active) active.classList.add('active');
        }
      });
    },
    {
      // Trigger when a section enters the top 40% of the viewport
      rootMargin: '-80px 0px -60% 0px',
    },
  );

  sections.forEach((s) => observer.observe(s));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
